//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
data() {
return {
    indexID:0,
    InvTitle:`温馨提示：1.根据税局规定，实付金额需满100元及以上才可开具增值税专用发票；<br/> 2.本平台自2019年11月起，客户如果要开增值税专票需要另行支付发票快递费用； <br/>3.订单发票会在用户点击【确认收货】后3-5个工作日内开具；<br/> 4.货物或应税劳务、服务名称：塑料手板或金属手板 商品分类：塑料制品或金属制品。如果给您带来不便敬请谅解谢谢合作。`,
    InvoiceList:['普通发票','增值税发票','收据']
}
},
methods: {},
mounted() {},
created() {},
props:{},
watch:{ },
components:{}
}



// WEBPACK FOOTER //
// ./src/views/openInvoice/openInvoice.vue